import { render, staticRenderFns } from "./digital_module.vue?vue&type=template&id=03ed611a&scoped=true"
import script from "./digital_module.vue?vue&type=script&lang=js"
export * from "./digital_module.vue?vue&type=script&lang=js"
import style0 from "./digital_module.vue?vue&type=style&index=0&id=03ed611a&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03ed611a",
  null
  
)

export default component.exports